import type {FormEvent} from 'react'
import {useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router'
import {fromJust} from '@freckle/maybe'
import type {TranslateT} from '@freckle/educator-entities/ts/common/helpers/translate'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import ApiHelper from '@freckle/school/ts/common/helpers/api-helper'
import Notification from '@freckle/school/ts/common/helpers/notification'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import SetPassword from '@freckle/school/ts/pages/set-password/set-password'

type SetPasswordError = {
  status: number
  responseJSON: {
    errors: Array<string>
  }
}

function parseErrorResponse(data: SetPasswordError, t: TranslateT): string {
  if (data.status === 400) {
    return data.responseJSON.errors[0]!
  } else {
    return t('LOGIN_PAGE_PASSWORD_PARSE_ERROR_MESSAGE_TEXT')
  }
}

export function SetPasswordContainer() {
  const {t} = useSafeTranslation()
  const [state, setState] = useState({
    password: '',
    passwordConfirm: '',
    loading: false
  })
  const navigate = useNavigate()
  const [searchParams, _setSearchParams] = useSearchParams()

  const onChangePassword = (password: string) => {
    setState({...state, password})
  }

  const onChangePasswordConfirm = (passwordConfirm: string) => {
    setState({...state, passwordConfirm})
  }

  const onSubmit = (e: FormEvent<HTMLFormElement>, t: TranslateT) => {
    e.preventDefault()
    const {password, passwordConfirm} = state
    const schoolAdminId = parseInt(
      fromJust(searchParams.get('id'), 'No school admin id supplied.'),
      10
    )
    if (password !== passwordConfirm) {
      Notification.displayErrorNotification(t('LOGIN_PAGE_PASSWORD_MATCH_ERROR_MESSAGE_TEXT'))
      return
    }

    setState({...state, loading: true})

    ApiHelper.setPassword(schoolAdminId, password).then(
      () => {
        setState({...state, loading: false})
        navigate(Routes.login())
      },
      data => {
        setState({...state, loading: false})
        Notification.displayErrorNotification(parseErrorResponse(data, t))
      }
    )
  }

  return (
    <SetPassword
      password={state.password}
      passwordConfirm={state.passwordConfirm}
      onChangePassword={onChangePassword}
      onChangePasswordConfirm={onChangePasswordConfirm}
      onSubmit={e => onSubmit(e, t)}
      loading={state.loading}
    />
  )
}
